import type { ResourceDetail } from '@fabric-app/types/resources';
import { useResourceUserPinToHomescreen } from '@fabric-app/business/resource-pin/mutations/useMutationResourceUserPin';
import { DropdownMenu } from '@fabric-app/ui/components/DropdownMenu/DropdownMenu';
import { IconPin } from '@fabric-app/icons/mobile';

export const DropdownItemPinToHome: React.FC<{ resource: ResourceDetail }> = ({ resource }) => {
  const { togglePin, pinLabel } = useResourceUserPinToHomescreen(resource);
  return (
    <DropdownMenu.Item
      iconElement={<IconPin />}
      onSelect={togglePin}
      data-testid="fdoc-list-context-menu-pin-to-home"
    >
      {pinLabel}
    </DropdownMenu.Item>
  );
};
